module.exports = __webpack_public_path__ + "static/media/PaperAirplanes.5cfdd97a.png";